import React, { useState } from 'react';
import { authApi } from '../../api'; 
import { setAuthToken } from '../../api/authSession';
import { useNavigate } from 'react-router-dom';

const CodeVerification = ({ username }) => {
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await authApi.verifyCode(username, code);

            if (res.data.token) {
                // Store the JWT token in session storage & initialize activity timer
                setAuthToken(res.data.token);
                alert("✅ Verification successful! Launching dashboard.");
                
                // Redirect to the protected root path
                navigate('/'); 
                window.location.reload(); // Force full reload to update protected routes
            }
        } catch (err) {
            alert("❌ Verification failed. Invalid code or session expired.");
            console.error("Verification Error:", err);
            setCode('');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-card verification-card">
            {/* 2FA Shield / Radar Icon */}
            <div className="auth-shield-icon-wrapper">
                <i className="fas fa-fingerprint"></i>
            </div>

            <h2>2FA Security Check</h2>
            <div className="auth-tagline">Two-Factor Authentication</div>

            <p className="auth-subtext">
                A 4-digit verification code has been sent to <strong>{username || "your registered email"}</strong>.
            </p>

            <form onSubmit={handleSubmit} className="auth-form">
                <div className="auth-input-group">
                    <label>Enter 4-Digit Security Code</label>
                    <div className="auth-input-box otp-input-box">
                        <input
                            type="text"
                            placeholder="••••"
                            value={code}
                            onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, ''))}
                            maxLength="4"
                            required
                            autoFocus
                        />
                    </div>
                </div>

                <button 
                    type="submit" 
                    className="admin-btn-primary auth-submit-btn"
                    disabled={code.length !== 4 || loading}
                >
                    {loading ? (
                        <>
                            <i className="fas fa-circle-notch fa-spin"></i> Verifying...
                        </>
                    ) : (
                        <>
                            <i className="fas fa-shield-alt"></i> Verify &amp; Launch Console
                        </>
                    )}
                </button>
            </form>

            <p className="auth-footer-link">
                Wrong account? <a href="/login" onClick={(e) => { e.preventDefault(); window.location.reload(); }}>Back to Login</a>
            </p>
        </div>
    );
};

export default CodeVerification;